import React, { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { industries } from '../../data/industries';
import { Button } from '../ui/Button';
const types = ['Permanent', 'Interim', 'Contract', 'Fixed-term'];
const field = 'h-12 w-full rounded-md border border-line bg-white px-3.5 text-[15px] text-ink placeholder:text-muted/70 transition-[border-color,box-shadow] duration-150 focus:border-midnight focus:outline-none focus:ring-2 focus:ring-gold/40';
export function JobSearchPanel() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [industry, setIndustry] = useState('');
  const [location, setLocation] = useState('');
  const [type, setType] = useState('');
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q.trim()) params.set('q', q.trim());
    if (industry) params.set('industry', industry);
    if (location.trim()) params.set('location', location.trim());
    if (type) params.set('type', type);
    navigate(`/jobs${params.toString() ? `?${params}` : ''}`);
  };
  return <section aria-labelledby="search-heading" className="relative z-10 -mt-20" data-id="element-235" data-mp="2a82rc2h277zv">
      <div className="container-page" data-id="element-236" data-mp="2o7c7j259m23u">
        <form onSubmit={onSubmit} className="rounded-xl border border-line bg-white p-5 shadow-lift md:p-7" data-id="element-237" data-mp="2j6o75pv5c8wy">
          <h2 id="search-heading" className="font-display text-2xl font-semibold text-ink" data-id="element-238" data-mp="2x67fainyjk99">
            Search opportunities
          </h2>
          <div className="mt-5 grid gap-4 md:grid-cols-2 lg:grid-cols-[1.5fr_1.2fr_1fr_1fr_auto] lg:items-end" data-id="element-239" data-mp="2t42mtn98wto7">
            <div data-id="element-240" data-mp="36vh5fsz8qsuq">
              <label htmlFor="hs-q" className="mb-1.5 block text-sm font-medium text-ink" data-id="element-241" data-mp="36y3c7qeb54bw">
                Job title or keyword
              </label>
              <input id="hs-q" value={q} onChange={e => setQ(e.target.value)} placeholder="e.g. Chief Financial Officer" className={field} data-id="element-242" data-mp="3gvhs9owbjr3o" />
            </div>
            <div data-id="element-243" data-mp="3iyjtsminrala">
              <label htmlFor="hs-industry" className="mb-1.5 block text-sm font-medium text-ink" data-id="element-244" data-mp="3iz1xg47ngr38">
                Expertise
              </label>
              <select id="hs-industry" value={industry} onChange={e => setIndustry(e.target.value)} className={field} data-id="element-245" data-mp="3ny68z1i1r0wq">
                <option value="" data-id="element-246" data-mp="3suwlxfyk1gdx">All industries</option>
                {industries.map(i => <option key={i.slug} value={i.slug} data-id="element-247" data-mp="1jv6ouhden0e">
                    {i.name}
                  </option>)}
              </select>
            </div>
            <div data-id="element-248" data-mp="ah5gscigc63q">
              <label htmlFor="hs-location" className="mb-1.5 block text-sm font-medium text-ink" data-id="element-249" data-mp="aktbvg3jp0kk">
                Location
              </label>
              <input id="hs-location" value={location} onChange={e => setLocation(e.target.value)} placeholder="City or remote" className={field} data-id="element-250" data-mp="khfurzcb9hjy" />
            </div>
            <div data-id="element-251" data-mp="2hbj2gmkne9hm">
              <label htmlFor="hs-type" className="mb-1.5 block text-sm font-medium text-ink" data-id="element-252" data-mp="2m811d5tardm1">
                Employment type
              </label>
              <select id="hs-type" value={type} onChange={e => setType(e.target.value)} className={field} data-id="element-253" data-mp="2eqb8936g5pyr">
                <option value="" data-id="element-254" data-mp="29wqly8e7ukfe">Any type</option>
                {types.map(t => <option key={t} data-id="element-255" data-mp="24zgl7wldmmc9">{t}</option>)}
              </select>
            </div>
            <Button type="submit" variant="navy" size="lg" className="md:col-span-2 lg:col-span-1" data-id="element-256" data-mp="201f1d9g4mizq">
              <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-257" data-mp="2xmuo0bbrac4a" />
              Search
            </Button>
          </div>
        </form>
      </div>
    </section>;
}